<template>
  <div class="px-4">
    <v-container fluid>
      <v-row align-content="center">
        <v-col
          style="position: fixed;z-index: 9999999999;bottom:0;right: 0;height: 94%"
          v-if="showBot"
          md="6"
          lg="3"
          cols="12"
          class="ful"
        >
          <v-icon
            style="position: absolute;left: 18px;z-index: 99;top:18px;cursor: pointer"
            @click="showBot = false"
            >mdi-close</v-icon
          >
          <iframe
            style="box-shadow: 0 0 22px #b1b1b1;border-radius: 8px"
            width="100%"
            height="100%"
            :src="
              $cookies.get('lang') === 'en'
                ? `https://chat-widget.curvs.ai/LsWHFNfU69185a4aada69964113653?pair=${chatBotPair}&fullScreen=true`
                : `https://chat-widget.curvs.ai/K9KZN2H26874a651a29c6822032222?pair=${chatBotPair}&fullScreen=true`
            "
            frameborder="0"
          ></iframe>
        </v-col>
        <!--right com-->
        <v-col md="3" cols="12" class="pa-1">
          <tradeForms @refresh="refresh" ref="tradeForms" />
        </v-col>
        <!--center com-->
        <v-col md="9" cols="12" class="py-0 px-3">
          <v-row>
            <v-col cols="12" class="pa-1">
              <currentCard @loadCurvsScript="showBot = !showBot" />
            </v-col>
            <v-col md="9" cols="12" class="pa-1">
              <tradeCharts :current-coin="currentCoin" />
            </v-col>
            <v-col md="3" cols="12" class="pa-1">
              <template v-if="currentCoin">
                <preMarket
                  v-if="showPremarket"
                  :countDownBgColor.sync="countDownBgColor"
                  :publishState.sync="publishState"
                  :clearTime="currentCoin.clearTime"
                  :currentTime="parseInt(currentCoin.currentTime / 1000)"
                  :endTime="currentCoin.endTime"
                  :publishType="currentCoin.publishType"
                  :startTime="currentCoin.startTime"
                  @hidePremarket="hidePremarket"
                  @hidePublishMask="hidePublishMask"
                  @showPublishMask="showPublishMask"
                />
              </template>
              <plateTables @updateTradeForms="updateTradeForms" />
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12">
          <orderTables
            v-if="currentCoin && isAuth"
            :key="reloadData || $route.params.pair"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import preMarket from "@/components/Market/exchange/preMarket.vue";
// import marketsList from "@/components/Market/exchange/MarketList.vue";
import currentCard from "@/components/Market/exchange/currentCard.vue";
import plateTables from "@/components/Market/exchange/plateTables.vue";
import orderTables from "@/components/Market/exchange/orderTables.vue";
import tradeForms from "@/components/Market/exchange/tradeForms/index.vue";
import tradeCharts from "@/components/Market/exchange/tradeCharts/index.vue";
import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";
import { authMixin } from "@/mixins/authMixin";
import dayjs from "dayjs";
import { MarketMarketService } from "@/services";

export default {
  name: "exchange",
  mixins: [authMixin],
  components: {
    orderTables,
    plateTables,
    currentCard,
    // marketsList,
    tradeForms,
    tradeCharts,
    preMarket
  },
  data() {
    return {
      countDownBgColor: "#003478",
      publishState: 0,
      reloadData: false,
      showBot: false,
      chatBotPair: "USDT_IRR"
    };
  },
  mounted() {
    this.getPairCoinScales();
    if (!this.$route.params.pair) {
      this.$router.push({
        path: `/exchange/USDT_IRR`
      });
    }
  },
  watch: {
    currentCoin: {
      handler: function() {
        document.title = `${this.currentCoin.symbol}`;
        this.chatBotPair = this.currentCoin.symbol;
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters({
      currentCoin: types.marketExchange.getters.GET_CURRENT_COIN
    }),
    showPremarket: {
      get() {
        if (
          dayjs(this.currentCoin.currentTime).format("YYYY-MM-DD HH:mm:ss") <
          this.currentCoin.clearTime
        ) {
          return (
            this.currentCoin.publishType === "QIANGGOU" ||
            this.currentCoin.publishType === "FENTAN"
          );
        } else {
          return false;
        }
      },
      set(newValue) {
        return newValue;
      }
    },
    showPublishMarket: {
      get() {
        if (
          dayjs(this.currentCoin.currentTime).format("YYYY-MM-DD HH:mm:ss") <
          this.currentCoin.clearTime
        ) {
          return (
            this.currentCoin.publishType === "QIANGGOU" ||
            this.currentCoin.publishType === "FENTAN"
          );
        } else {
          return false;
        }
      },
      set(newValue) {
        return newValue;
      }
    }
  },
  methods: {
    ...mapActions({
      setCoinScales: types.marketExchange.actions.SET_COIN_SCALES
    }),
    showPublishMask() {
      if (!this.showPublishMarket) {
        this.showPublishMarket = true;
      }
    },
    hidePublishMask() {
      if (this.showPublishMarket) {
        this.showPublishMarket = false;
      }
    },
    hidePremarket() {
      if (this.showPremarket) {
        this.showPremarket = false;
      }
    },
    updateTradeForms(itemValue) {
      this.$refs.tradeForms.$refs.form.setPLateData(itemValue.price);
    },
    refresh() {
      this.reloadData = !this.reloadData;
    },
    getPairCoinScales() {
      console.log();

      MarketMarketService.getPairCoinScales().then(res => {
        this.setCoinScales(res.data.data);
      });
    }
  }
};
</script>
